import { render, staticRenderFns } from "./IDOM.vue?vue&type=template&id=f454ab6e"
import script from "./IDOM.vue?vue&type=script&lang=js"
export * from "./IDOM.vue?vue&type=script&lang=js"
import style0 from "./IDOM.vue?vue&type=style&index=0&id=f454ab6e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports